import styled, { css } from 'styled-components';
import {
	mediaMin,
	mediaMax,
} from "../../../../../shared/style"

const Card = styled.div`
  box-sizing: border-box;
  padding: 24px;
  gap: 8px;
  width: 100%;
  height: 100px;
  background: #FFFFFF;
  /* container/ig */
  border: 1px solid #DEDFE2;
  border-radius: 4px;
  margin-top: 8px;

  ${mediaMax.phone`
    height: 88px;
    border: none;
    padding: 24px 0px;
    margin-top: 0px;
  `};
`;

const CompletedStepTitleBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;

`;

const CompletedStepIconBox = styled.div`
  width: 20px;
  height: 20px;
`;

const CompletedStepTitleIcon = styled.i`
  font-family: 'Font Awesome 5 Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  /* identical to box height, or 125% */
  display: flex;
  align-items: center;
  text-align: center;
  color: #B9BBC1;
`;

const CompletedStepTitleText = styled.h3`
  /* header/h2 */
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 133% */
  display: flex;
  align-items: center;
  margin: 0px;

  /* text/default */
  color: #3E4148;

  ${mediaMax.phone`
    font-size: 16px;
    line-height: 20px;
  `};
`;

const CompletedStepSubtitle = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  /* identical to box height, or 125% */
  display: flex;
  align-items: center;
  margin: 8px 0px 0px 0px;
  padding-left: 28px;

  /* text / secondary */
  color: #6E727C;

  ${mediaMax.phone`
    margin: 4px 0px 0px 0px;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  `};
`;

export default {
	Card,
	CompletedStepTitleBox,
	CompletedStepIconBox,
	CompletedStepTitleIcon,
	CompletedStepTitleText,
	CompletedStepSubtitle
}

